<template>
    <div>
        <v-card flat>
            <v-card-text>
                <v-data-table
                    :headers="tabledata"
                    :items="rfidList"
                    dense
                    :height="height"
                    class="overflow-y-auto overflow"
                    :items-per-page="10"
                    :fixed-header="fixed"
                    :loading="isLoading"
                    loading-text="Loading... Please wait"
                    :footer-props="{
                        'items-per-page-options': [10, 15, 20, 25],
                    }"
                >
                <template v-slot:[`item.box_name`]="{ item }">
            {{item.box_name || "-" }}
          </template>
          <template v-slot:[`item.total_count_of_swipes`]="{ item }">
            {{item.total_count_of_swipes || "-" }}
          </template>
                <template v-slot:[`item.box_created_on`]="{ item }">
            {{ formatReadableDate(item.box_created_on) || "-" }}
          </template>
          <template v-slot:[`item.box_claimed_on`]="{ item }">
            {{ formatReadableDate(item.box_claimed_on) || "-" }}
          </template>
           <template v-slot:[`item.is_claimed`]="{ item }">
    <span :class="item.is_claimed ? 'red--text' : 'green--text'">
      {{ item.is_claimed ? 'Yes' : 'No' }}
    </span>
  </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-icon
              v-if="!item.is_claimed"
              small
              color="red"
              class="mr-2"
              @click.stop="claim_box(item)"
            >
              mdi-plus
            </v-icon>
            <span v-else>-</span>
          </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <Overlay :overlay="overlay" />
    <SnackBar :SnackBarComponent="SnackBarComponent" />
        <div v-if="componentCheck == 1">
          <ClaimRfidBox :claimboxDialog="claimboxDialog" :boxData="boxData" @clicked="claimboxDialog = false"
           v-on:errorMsg="error_info"
        v-on:successMsg="success_info"
          />
        </div>
    </div>
</template>
<script>
import ClaimRfidBox from "@/components/Dialogs/ClaimRfidBox.vue";
import { API, graphqlOperation } from "aws-amplify";
import { getRfid } from "@/graphql/queries.js";
import SnackBar from "@/components/SnackBar.vue";
import Overlay from "@/components/Overlay.vue";
export default {
  components: {
    ClaimRfidBox,
    SnackBar,
    Overlay,
  },
    data: () => ({
    fixed: true,
    isLoading: false,
    height: 0,
    rfidList: [],
     tabledata: [
      { text: "Box Id", value: "box_id" },
      { text: "Box Name", value: "box_name" },
      { text: "Created On", value: "box_created_on" },
      { text: "Claimed", value: "is_claimed" },
      { text: "Claimed On", value: "box_claimed_on" },
      { text: "Swipes", value: "total_count_of_swipes" },
      { text: "Action", value: "action" },
    ],
    componentCheck: 0,
    SnackBarComponent: {},
    overlay: false,
    claimboxDialog: false,
    boxData: {},
  }),
  created() {
    this.height = window.innerHeight - 205;
    this.get_Rfid_list();
  },

  methods: {
    claim_box(item) {
      this.componentCheck = 1;
      this.claimboxDialog = true;
      this.boxData = item;
    },
     error_info(val) {
      this.SnackBarComponent = {
        SnackbarVmodel: true,
        SnackbarColor: "red",
        SnackbarText: val,
        timeout: 5000,
        Top: true,
      };
    },

    success_info(val) {
      this.SnackBarComponent = {
        SnackbarVmodel: true,
        SnackbarColor: "green",
        SnackbarText: val,
        timeout: 5000,
        Top: true,
      };
      this.claimboxDialog = false;
      this.get_Rfid_list();
    },
    async get_Rfid_list() {
  this.isLoading = true;
  this.overlay = true;

  try {
    const result = await API.graphql(
      graphqlOperation(getRfid, {
        input: {
          organisation_id:
                this.$store.getters.get_org_details[0].organisation_id,
        },
      })
    );

    const response = JSON.parse(result.data.getRfid);

    if (response.Status === "Success" && Array.isArray(response.data) && response.data.length > 0) {
      // ✅ If data exists
      this.rfidList = response.data;
    } else {
      // ⚠️ If failed OR no data
      this.rfidList = [];
      this.SnackBarComponent = {
        SnackbarVmodel: true,
        SnackbarColor: "red",
        Top: true,
        SnackbarText: response.Message || "No Record Found",
        timeout: 4000,
      };
    }
  } catch (err) {
    console.log("error", err);
    this.rfidList = [];
    this.SnackBarComponent = {
      SnackbarVmodel: true,
      SnackbarColor: "red",
      Top: true,
      SnackbarText: err.errors?.[0]?.message || "Error fetching RFID list",
      timeout: 4000,
    };
  } finally {
    this.isLoading = false;
    this.overlay = false;
  }
},
formatReadableDate(timestamp) {
      if (!timestamp) return "";
      const ts = timestamp.toString().length === 10 ? timestamp * 1000 : timestamp;
      const date = new Date(Number(ts));
      const options = { day: "2-digit", month: "short", year: "numeric" };
      return date.toLocaleDateString("en-US", options);
    },
  }
}
</script>